import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetManufacturerByIdQuery, useUpdateManufacturerMutation } from "../../redux/api/manufacturersApi";
import ManufacturerForm from "./ManufacturerForm";
import { toast } from "react-toastify";

const EditManufacturerPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: manufacturer, isLoading, error } = useGetManufacturerByIdQuery(id);
  const [updateManufacturer, { isLoading: isUpdating }] = useUpdateManufacturerMutation();

  const handleUpdateManufacturer = async (formData) => {
    try {
      await updateManufacturer({ ...formData, id }).unwrap();
      toast.success("Manufacturer updated successfully!");
      navigate("/manufacturers");
    } catch (err) {
      toast.error(err?.data?.message || err?.error || "Failed to update manufacturer");
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error?.data?.message || error?.error || 'Failed to load manufacturer'}</div>;
  if (!manufacturer) return <div>Manufacturer not found</div>;

  return (
    <div>
      <h1 className="mb-4">Edit Manufacturer</h1>
      <ManufacturerForm manufacturer={manufacturer} onSubmit={handleUpdateManufacturer} loading={isUpdating} />
    </div>
  );
};

export default EditManufacturerPage;
